import React, { useContext, useState, KeyboardEvent } from "react"
import { useCopy } from "../components/copy-hook";
import { Loading } from "../components/Loading";
import { Modal } from "../components/Modal";
import { load } from "../loaders/basic-loader";
import { AuthContext, useIsGuest } from "../login/AuthContext"
import { WhatsAppMarkdown } from "../whats-markdown/WhatsAppMarkdown";

function QueryModal(){
    const [question, setQuestion] = useState("");
    const [response, setResponse] = useState("");
    const [loading, setLoading] = useState(false);
    const user = useContext(AuthContext)?.user
    const copy = useCopy();

    async function checkEnter(e:KeyboardEvent){
        if(e.key == 'Enter'){
            setLoading(true);
            setResponse((await load("wa-query", {}, {query: question})).response);
            setQuestion("");
            setLoading(false);
        }
    }

    function doCopy(){
        copy(response);
    }

    if(!user?.isAdmin)
        return null;

    return <div>
        {loading && <Loading />}
        {response && <div className="wa-text">
            <div>
                <button style={{float:"right"}} className="btn btn-primary right" onClick={doCopy}><i className="fa fa-copy"></i></button>
                <WhatsAppMarkdown message={response} />
            </div>
        </div>}
        <input placeholder="Command..." enterKeyHint="enter" onKeyUp={checkEnter} value={question} className="form-control mt-4" onChange={(e) => setQuestion(e.target.value)} />
    </div>
}

export function WaQueryButton(){
    if(location.host.match(/\.io/))
        return null;
    const user = useContext(AuthContext)?.user
    const [show, setShow] = useState(false);

    return <>
        <button className="btn btn-primary me-2 mb-2" onClick={() => setShow(true)}><i className="fa fa-desktop"></i> Comandos</button>
        {show && <Modal className="modal-primary" onHide={() => setShow(false)} title="Comandos"><QueryModal /></Modal>}
    </>
}